import { FormikErrors, FormikTouched } from "formik";
import React from "react";
import { FormSectionStatus } from "../lib/models/form-section-status.model";

function useSectionValidation(
  sections: FormSectionStatus[],
  touchedFields: FormikTouched<any>,
  formErrors: FormikErrors<any>,
  dirty: boolean
) {
  const [validatedSections, setValidatedSections] = React.useState(sections);

  const validateSection = React.useCallback(
    (
      section: FormSectionStatus,
      touched: string[],
      errors: string[],
      dirty: boolean
    ) => {
      const sectionFieldCount =
        section.fields.length - (section.numberOfOptionalFields ?? 0);
      let errorCount = 0;
      let touchCount = 0;

      if (sectionFieldCount < 1) {
        section.status = "info";
        return;
      }

      for (let i = 0; i <= touched.length - 1; i++) {
        if (section.fields.includes(touched[i])) {
          touchCount++;
        }
      }

      for (let i = 0; i <= errors.length - 1; i++) {
        if (section.fields.includes(errors[i])) {
          errorCount++;
        }
      }

      if (errorCount < 1 && touchCount < 1) {
        section.status = "success";
      } else if (errorCount > 0 && touchCount > 0) {
        section.status = "error";
      } else if (errorCount < 1 && touchCount > 0) {
        section.status = "success";
      } else {
        section.status = "info";
      }
    },
    []
  );

  const validateSections = React.useCallback(
    (sections: FormSectionStatus[]) => {
      const validated = [...sections];
      const touchedKeys = Object.keys(touchedFields);
      const errorKeys = Object.keys(formErrors);

      validated.forEach((section) => {
        validateSection(section, touchedKeys, errorKeys, dirty);
      });

      setValidatedSections(validated);
    },
    [touchedFields, formErrors, dirty, validateSection]
  );

  React.useEffect(() => {
    validateSections(sections);
  }, [sections, validateSections]);

  return [validatedSections];
}

export default useSectionValidation;
